import React from 'react';
import SegmentPageTemplate from '../components/SegmentPageTemplate';
import segmentConfigs from '../config/segmentConfigs';

const LocacaoCondominio = () => {
  return <SegmentPageTemplate {...segmentConfigs.condominio} />;
};

export default LocacaoCondominio;